import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@theHescoBlueprint/Handlers/CustomHandlerCreator";
import { RFQIsSalesOnlyPropertyState } from "@theHescoBlueprint/Handlers/RFQIsSalesOnlyPropertyState";

type HandlerType = CustomHandler<any, any>;

export const SetRFQIsSalesOnlyProperty: HandlerType = props => {
    props.dispatch({
        type: "Custom/RFQIsSalesOnly/IsSalesOnlyProperty",
    });
};

export const chain = [SetRFQIsSalesOnlyProperty];

export const updateIsSalesOnlyProperty = createHandlerChainRunner(chain, "UpdateIsSalesOnlyProperty");
export default updateIsSalesOnlyProperty;
